
export function analizeOrdersListDatetime(companyId, storage) {
    const ordersList = storage.get('DELIVERY_ACCOUNT_SESSION');

    if(ordersList){
        const sameCompanyId = companyId == ordersList.company_id ? true : false;

        const hours = Math.floor((Date.now() - ordersList.created_at) / (1000 * 60 * 60)) % 24;
    
        const inTime = hours <= 4 ? true : false;

        if(!inTime || !sameCompanyId){
            localStorage.removeItem('DELIVERY_ACCOUNT_SESSION');
        }

    }

    return;
}